import { render, staticRenderFns } from "./Callbacks.vue?vue&type=template&id=21aea1cf&scoped=true&"
import script from "./Callbacks.vue?vue&type=script&lang=ts&"
export * from "./Callbacks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21aea1cf",
  null
  
)

export default component.exports